import { PropsWithChildren, ReactNode } from 'react';

interface ScrollablePageWrapperProps extends PropsWithChildren {
  /** The navbar element to render inside the scroll container (sticky at top) */
  navbar: ReactNode;
}

/**
 * Wraps a navbar + page content in a single scroll container so that
 * content scrolls behind the sticky navbar, enabling the glass
 * backdrop-filter blur effect.
 *
 * Mirrors the NextGenLayout pattern that already works.
 */
export function ScrollablePageWrapper({ navbar, children }: ScrollablePageWrapperProps) {
  return (
    <div className="flex flex-col h-screen md:h-full">
      {/* Single scrollable area — sticky nav stays at top, content flows below */}
      <div className="flex-1 overflow-auto w-full">
        {navbar}
        <div className="pb-16 md:pb-0">
          {children}
        </div>
      </div>
    </div>
  );
}
